<template>
  <div class="login-wrapper">
    <div class="container-fluid bg">
      <div class="row justify-content-center align-items-center login overflow-scroll">

        <div class="smartphone-img">
          <img src="../assets/img/tel_appli.png" alt="smartphone-img">
        </div>

        <div class="card border-0 mb-0">

          <!-- Header and logo -->
          <div class="card-header text-center p-t-0">
            <img class="logo-style img-fluid" src="../assets/img/logo_connexion_ts.png" alt="logo-black" width="250" height="43">
          </div>
          <!-- End of header and logo -->

          <!-- Body -->
          <div class="card-body text-justify">
            <p class="mb-4">
              {{ $i18n.t('SignUpConfirmation.message_beggining') }}
              <b>{{ $i18n.t('SignUpConfirmation.message_middle') }}</b>
              {{ $i18n.t('SignUpConfirmation.message_end') }}
            </p>
            <p>
              <b>{{ $i18n.t('SignUpConfirmation.receive_email_activated') }}</b>
            </p>
          </div>
          <!-- End of body -->

          <footer-confirmation-page />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FooterConfirmationPage from './FooterConfirmationPage'

  export default {
    name: 'SignUpConfirmationPage',
    components: {
      FooterConfirmationPage
    },
  }
</script>

<style lang="scss" scoped>
  .bg {
    background-color: #fff;
  }
  .overflow-scroll {
    overflow: auto;
  }
  .login {
    height: 100vh;
  }
  .card {
    padding: 1rem 1rem 1rem;
  }
  .card-body {
    margin-bottom: 12rem;
  }

  @media (max-width: 767px) {
    .card {
      min-height: 100vh;
    }
    .logo-style {
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .card-footer {
      position:absolute;
      bottom:0;
      align-self: center;
    }
    .card-body {
      padding: 15px;
    }
    .smartphone-img {
      display: none;
    }
  }

  @media (min-width: 768px) {
    .card {
      padding: 0rem 4rem 2rem;
      border-radius: 15px;
      max-width: 600px;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    .card-header {
      padding-right: 0px;
    }
    .bg {
      background: url('/static/img/signin_form.jpg');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
    }
    .logo-style {
      position: fixed;
      top: 20px;
      left: 20px;
      margin: 0px;
      width: 350px;
      height: auto;
    }
    .smartphone-img {
      position: fixed;
      bottom: -15px;
      right: -15px;
    }
    .smartphone-img > img {
      height: 450px;
      width: auto;
    }
  }

  @media (min-width: 768px) and (max-width: 1400px) and (orientation: portrait) {
    .logo-style {
      position: fixed;
      top: 20px;
      left: 50%;
      margin: 0px;
      align-content: center;
      transform: translate(-50%);
    }
    .smartphone-img {
      display: none;
    }
  }

  /* avoids logo overlap when tablet is used in landscape orientation */
  @media (min-width: 768px) and (max-width: 1400px) and (orientation: landscape) {
    .logo-style {
      position: static;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .smartphone-img {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SignUpConfirmationPage.vue